@if (login.loginStep === 'CREDENTIALS') {
  <app-login-mobile-credentials-step></app-login-mobile-credentials-step>
}

@if (login.loginStep === 'MFA') {
  <app-login-mobile-mfa-step></app-login-mobile-mfa-step>
}
